import emailIcon from '../../assets/mdi_alternate-email-white.svg'
import phoneIcon from '../../assets/mdi_phone-white.svg'

export function ReferenceItem(
  {
    name,
    title,
    email,
    phone
  }: {
    name: string,
    title: string,
    email:string,
    phone: string
  }) {
  return(
    <div className="reference dark-bg">
          <h3>{name}</h3>
          <p>{title}</p>
          <ul className="no-deco">
            <li className="flex"><img className="icon-inline" src={emailIcon} alt="e-mail icon"></img>{email}</li>
            <li className="flex"><img className="icon-inline" src={phoneIcon} alt="phone icon"></img>{phone}</li>
          </ul>
        </div>
  )
}